
export default class Controller{
    constructor(pageInfo){
        this.pages = {
            obj: pageInfo,
            list: Object.keys( pageInfo ),
            direction: '',
            currPage: '',
            nextPage: '',
        };
        this.leady = false;
        this.change = (key)=> this._change(key);
        this.isDirection = ()=>{
            return this.pages.direction
        };
        this.hide = ()=> this._hide();

        this._bindEvent();
    }

    init(currPage){
        this.pages.currPage = this.pages.obj[currPage];
        if( this.pages.currPage.class.pageTl ) this.pages.currPage.class.pageTl.seek(0.3);
        this.pages.currPage.class.show();
    }

    _hide(){
        this.pages.currPage.class.hideMotion.seek(0);
        this.pages.currPage.class.hideMotion.play();
    }

    _change(key){
        this.pages.nextPage = this.pages.obj[key];
        if( this.pages.nextPage == this.pages.currPage ){
            return;
        }

        this.pages.direction = this.pages.list.indexOf( this.pages.currPage.key ) < this.pages.list.indexOf( this.pages.nextPage.key ) ? 'next' : 'prev';
        this.leady = false;
        if( this.pages.currPage ){
            this.pages.currPage.class.hide();
        }
        else{
            this.pages.currPage.class.show();
        }
        this.pages.currPage = this.pages.nextPage;
    }

    _hideComplete(){
        if( this.pages.nextPage ){
            this.pages.nextPage.class.pageTl.seek(0);
            this.pages.nextPage.class.show( this.pages.direction );
            this.pages.nextPage = '';
        }
    }

    _triggerEvent(e){
        switch(e.type){
            case 'onComplete': {
                this.leady = true;
                break;
            }
            case 'hideComplete': {
                this._hideComplete();
                break;
            }
        }
    }

    _bindEvent(){
        let len;

        len = this.pages.list.length;
        while( len-- ){
            this.pages.obj[ this.pages.list[len] ].ele.addEventListener('onComplete', this._triggerEvent.bind(this) );
            this.pages.obj[ this.pages.list[len] ].ele.addEventListener('hideComplete', this._triggerEvent.bind(this) );
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/subDeath/subController.js